module.exports = __webpack_public_path__ + "static/img/1071.1c2bf93.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1071.jpg
// module id = 253
// module chunks = 0